<script>
  import compraServico from '../servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import Radio from '~componentes/Radio.vue';
  import projetoServico from '~modulos/projeto/servico';
  import { checkbox } from 'vue-strap';
  
  export default {
    components: { Paginacao, ModalArquivosSolicitacao, ModalMensagem, Radio, checkbox },
    data() {
      return {
        compras: [],
        carregando: false,
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        animated: true,
        modalArquivos: false,
        modalMensagem: false,
        solicitacaoSelecionada: null,
        configuracao: this.$storage.configuracao(),
        filtros: this.camposFiltros(),
        projetos: [],
      }
    },
    methods: {
      lista(pagina = 1) {
        this.carregando = true;
        
        return compraServico
          .lista(pagina, this.filtros)
          .then(dados => {
            this.carregando = false;

            this.compras = dados.registros;
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;
          });
      },
      listaDeProjetos() {
        return projetoServico
          .listaTodosProjetos()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      camposFiltros() {
        return {
          idProjeto: '',
          solicitacaoWeb: '',
          porNivel1: 0,
          porNivel2: 0,
          porNivel3: 0,
          porCompra: 0,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val('0');
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
    },
    created() {
      this.$root.botaoRetrocederMostrar = false;
    },
    mounted() {
      this.$root.botaoAcaoMostrar = false;
      this.$root.tituloDaPagina = 'Liberação de compras - Lista';
      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function (e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });

      this.lista();
    }
  }
</script>

<style scoped>
  .liberacao {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
    
    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada : ''"
                                tipo="compra"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                    tipo="SolCompra"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="numero">Solicitação compra</label>

                  <input type="text"
                         class="form-control"
                         id="numero"
                         v-model="filtros.solicitacaoWeb"
                         v-numero>
                </div>
              </div>

              <label class="control-label block">Liberação pendente</label>

              <div class="col-xs-1">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porNivel1" value="1" type="success" true-value="1" false-value="0">
                      Nível 1
                    </checkbox>
                  </div>
                </div>
              </div>

              <div class="col-xs-1">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porNivel2" value="1" type="success" true-value="1" false-value="0">
                      Nível 2
                    </checkbox>
                  </div>
                </div>
              </div>

              <div class="col-xs-1">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porNivel3" value="1" type="success" true-value="1" false-value="0">
                      Nível 3
                    </checkbox>
                  </div>
                </div>
              </div>

              <div class="col-xs-2">
                <div class="form-group">
                  <div class="checkbox">
                    <checkbox v-model="filtros.porCompra" value="1" type="success" true-value="1" false-value="0">
                      Liberação compra
                    </checkbox>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>


          <div class="ibox-footer">
            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Solicitação compra</th>
                    <th>Data</th>
                    <th>Projeto</th>
                    <th>Fornecedor</th>
                    <th class="text-center">Nível 1</th>
                    <th class="text-center">Nível 2</th>
                    <th class="text-center">Nível 3</th>
                    <th class="text-center">Liberação compra</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(compra, index) in compras">
                    <td>{{ compra.idSolicitacaoCompra }}</td>
                    <td>{{ compra.dataCompra | formatarData }}</td>
                    <td>{{ compra.nomeProjeto }}</td>
                    <td>{{ compra.complementoCompra || '---' }}</td>
                    <td class="text-center"><i v-if="compra.n1" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td class="text-center"><i v-if="compra.n2" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td class="text-center"><i v-if="compra.n3" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td class="text-center"><i v-if="compra.cl" class="fa fa-check-circle liberacao" v-tooltip="'Liberado'" aria-hidden="true"></i></td>
                    <td>
                      <router-link class="btn btn-primary btn-xs"
                                   active-class=""
                                   v-tooltip="'Visualizar e liberar'"
                                   :to="{ name: 'compra.relatorio', params: { id: compra.idCompra } }">
                        <i class="fa fa-file-text-o"></i>
                      </router-link>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos'"
                              @click="mostrarModalArquivos(compra.idSolicitacaoCompra)"
                              v-if="configuracao.usarArquivosSolicitacaoCompras">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              @click="mostrarModalMensagem(compra)"
                              v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolCompra)">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="6">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/compra/componentes/Lista.vue